// extracted by mini-css-extract-plugin
export default {"horizontalScrollWrapper":"G3f2092"};